import { WeekDaysSlots } from "../_models/Invitation";

export class ClockinWorkShiftMapper {
    static mapWorkShiftsLocalToServer(weekDaysTimeSlots: WeekDaysSlots | null) {

        if (!weekDaysTimeSlots) {
            return null;
        }

        const res = Object.entries(weekDaysTimeSlots).map(([weekday, ranges]) => {
            const res2 = ranges.map(({ start, end }) => ({
                start,
                end,
                weekday
            }))
            return res2
        })
        return res.flat();
    }
}